import { render, staticRenderFns } from "./InsertZone.vue?vue&type=template&id=6f76cab2&scoped=true&lang=pug&"
import script from "./InsertZone.vue?vue&type=script&lang=js&"
export * from "./InsertZone.vue?vue&type=script&lang=js&"
import style0 from "./InsertZone.vue?vue&type=style&index=0&id=6f76cab2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f76cab2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6f76cab2', component.options)
    } else {
      api.reload('6f76cab2', component.options)
    }
    module.hot.accept("./InsertZone.vue?vue&type=template&id=6f76cab2&scoped=true&lang=pug&", function () {
      api.rerender('6f76cab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layertree/component/InsertZone.vue"
export default component.exports